import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';

import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import CardBoard from '../utility/CardBoard';

// App Classes
import Alert from '../utility/Alert';
import Typography from '@material-ui/core/Typography';

import store from '../../store_actions/StudentStore';
import * as action from '../../store_actions/StudentActions';

//Tab Container
function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

// CSS Module
const styles = (theme) => ({
  root: {
    display: 'flex',
    width: '90%',
  },
  formControl: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'flex-start',
  },
  textFields: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    padding: 10,
    paddingBottom: 5,
    paddingTop: 5,
    marginBottom: 20,
  },
  selectView: {
    paddingTop: 20,
    width: 400,
    marginLeft: 10,
  },
  selectCityView: {
    display: 'flex',
    flexDirection: 'row',
    paddingTop: 20,
    width: '100%',
    marginLeft: 10,
    marginBottom: 20,
  },
  miniSelection: {
    paddingTop: 20,
    width: 220,
    marginRight: 10,
  },
  clientSelection: {
    paddingTop: 20,
    width: 320,
    marginRight: 10,
  },
  clientView: {
    paddingTop: 10,
    marginLeft: 10,
    marginRight: 10,
  },
  mapContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    height: 500,
    padding: 5,
  },
  group: {
    display: 'flex',
    flexDirection: 'column',
    width: 300,
  },
});

class GenerateID extends React.Component {
  constructor(props) {
    super(props);
    this.makeChanges = this.makeChanges.bind(this);
    this.state = {
      generate_number: 10,
    };
  }

  componentWillMount() {
    store.on('change', this.makeChanges);
  }

  makeChanges() {
    const { loading, generated } = store.generatedStatus();
    this.setState({
      loading: loading,
      generated: generated,
    });
  }

  //ALERT
  onDismiss = () => {
    this.setState({
      showAlert: false,
    });
    action.DissMiss();
  };

  onOkay = () => {
    this.setState((state) => ({
      showAlert: false,
    }));

    action.DissMiss();
  };

  onTapBack = () => {
    this.props.onTapBack();
  };

  onTapAddNewTask() {
    const { generate_number } = this.state;
    action.GenerateLogin({ qty: generate_number });
  }

  displayTextContent = () => {
    const { classes } = this.props;

    return (
      <view className={classes.formControl}>
        <view className={classes.textFields}>
          <TextField
            id="total-count"
            label="Numbers of ID to Generate:"
            style={{ width: '50%', marginTop: 0 }}
            rows="2"
            type="number"
            pattern="[0-9]*"
            required="true"
            margin="normal"
            onChange={(e) => {
              this.setState({
                generate_number: e.target.value,
              });
            }}
            value={this.state.generate_number}
          />
        </view>

        <view className={classes.textFields}>
          <Button
            variant="contained"
            color="primary"
            onClick={this.onTapAddNewTask.bind(this)}
            className={classes.button}
          >
            Generate
          </Button>
        </view>
      </view>
    );
  };

  render() {
    const { classes } = this.props;
    const { generated, title, msg, value } = this.state;

    return (
      <div>
        <Alert
          open={generated}
          onCancel={this.onOkay.bind(this)}
          onOkay={this.onOkay.bind(this)}
          title={'Add New IDs'}
          msg={'New IDs  Generated Successfully!'}
        />

        {/* <Alert
					open={showAlert}
					onCancel={this.onOkayForError.bind(this)}
					onOkay={this.onOkayForError.bind(this)}
					title={title}
					msg={msg}
				/> */}

        <Grid container spacing={24}>
          <Grid item xs={3}></Grid>
          <Grid item xs={6}>
            <CardBoard>{this.displayTextContent()}</CardBoard>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
      </div>
    );
  }
}

GenerateID.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(GenerateID);
